module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-tea-mill-finish-725-scale.178f53e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-tea-mill-finish-725-scale.jpg
// module id = 1125
// module chunks = 37